import { createApp } from 'vue';

import { clearSession } from './auth/session';
import App from './App.vue';
import router from './router';
import './styles.css';

window.addEventListener('eqs:unauthorized', () => {
  clearSession();
  const current = router.currentRoute.value;
  // 供应商等公开页（meta.public）没有账号：401 兜底不能把他们踢去登录页
  if (current.name !== 'login' && current.meta.public !== true) {
    void router.replace({
      name: 'login',
      query: { redirect: current.fullPath },
    });
  }
});

// 等首条路由解析完成再挂载：否则深链接冷启动时 meta.public 尚为空，
// AppShell 抢先挂载并发出需要登录的请求（401），把供应商踢到登录页（1022 实测复现）。
const app = createApp(App);
app.use(router);
void router.isReady().then(() => app.mount('#app'));
